import TradingViewChart from '../../components/Chart/TradingViewChart';
import withDimensions from '../../components/withSize';

const Chart = withDimensions(TradingViewChart);

const ChartDisplay = () => <Chart />;


export default ChartDisplay;
